:host {
  border: var(--size-px) solid var(--pos-border-color);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-md);
  padding: var(--size-8);
  max-width: var(--size-96);
  background: var(--pos-card-background);
}

.question {
  font-weight: var(--weight-semibold);
}

a {
  font-weight: var(--weight-bold);
  color: var(--pos-primary-color);
}

button.login {
  background: none;
  color: var(--pos-primary-color);
  display: inline;
  text-decoration: underline;
  border: none;
  padding: 0;
  margin: 0;
  cursor: pointer;
  font-size: unset;
}
